<template>
    <section>
        <v-layout row style="width: 88%;margin: auto;">
            <v-data-table :headers="headers" 
                        :items="GetAppliedJobs" 
                        item-key="Job_Title" 
                        class="elevation-1"
                        style="width:100%;margin-top:10px;">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Job_Title }}</td>
                        <td class="text-xs-center">{{ props.item.Name }}</td>
                        <td class="text-xs-center">{{ props.item.Phone_Number }}</td>
                        <td class="text-xs-center">{{ props.item.Email }}</td>
                        <td class="text-xs-center"> 
                            <a :href="props.item.Resume_URL" target=”_blank”>Click Here For Resume</a>
                        </td>
                        <td class="text-xs-center">
                        </td>
                    </tr>
                </template>
            </v-data-table>    
        </v-layout>
    </section>
</template>
<script>
export default {
    data(){
        return {
                headers : [ { text: 'Job Title',value: 'Job_Title' },
                            { text: 'Name',value: 'Name' },
                            { text: 'Phone_Number',value: 'Phone_Number' },
                            { text: 'Email',value: 'Email' },
                            { text: 'Resume_URL' , value : "Resume_URL"} ],
        }
    },
    computed:{
        GetAppliedJobs(){
            return this.$store.getters.GetAppliedJobs
        }
    },
    mounted(){
        this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/findjobsapplied`)
            .then(response =>{
                
                this.$store.commit('SetAppliedJobs',response["data"]["response"])
                this.$eventHub.$emit("LOADING",'false')
            })
            .catch(err =>{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
            })
    }
}
</script>
<style scoped>

</style>